import { gql } from 'graphql-tag'

/**
 * Siblings — two or more cases that are the same family.
 *
 * The sibling LIST itself is not here: it rides on the case as the `siblings`
 * virtual (see the case fragments), so a card already knows its family without
 * a second round-trip. These three are only the picker and the two writes.
 */

/** One case's siblings — the re-read after a link/unlink. */
export const CASE_SIBLINGS_QUERY = gql`
  query GetCaseSiblings($caseId: ID!) {
    getCaseSiblings(caseId: $caseId)
  }
`

/** Cases that look like this child's siblings, each with the reason it matched. */
export const SIBLING_CANDIDATES_QUERY = gql`
  query GetSiblingCandidates($caseId: ID!, $limit: Int) {
    getSiblingCandidates(caseId: $caseId, limit: $limit)
  }
`

export const LINK_CASE_SIBLINGS_MUTATION = gql`
  mutation LinkCaseSiblings($caseId: ID!, $siblingCaseId: ID!) {
    linkCaseSiblings(caseId: $caseId, siblingCaseId: $siblingCaseId)
  }
`

export const UNLINK_CASE_SIBLING_MUTATION = gql`
  mutation UnlinkCaseSibling($caseId: ID!) {
    unlinkCaseSibling(caseId: $caseId)
  }
`
